var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "header-container" },
    [
      _c("div", { staticClass: "search-container geoSearch" }, [
        _c(
          "form",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.geoSearch,
                expression: "geoSearch"
              }
            ],
            staticClass: "search-form geo-search-form",
            attrs: { action: "", id: "search-form" },
            on: { submit: _vm.submit }
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                ref: "searchTerm",
                staticClass: "search-input",
                attrs: {
                  name: "searchTerm",
                  type: "text",
                  placeholder: this.i18n.searchView.searchTermPlaceholder,
                  required: ""
                },
                on: { keyup: _vm.changedValue }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showResetButton,
                      expression: "showResetButton"
                    }
                  ],
                  staticClass: "ym-btn empty-search-button",
                  attrs: { type: "button" },
                  on: { click: _vm.emptySearchInput }
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
              )
            ]),
            _vm._v(" "),
            _vm.showInputLocalisationButton
              ? _c(
                  "button",
                  {
                    staticClass: "ym-btn localize-button",
                    attrs: { type: "button" },
                    on: { click: _vm.localizeInput }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("gps_fixed")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isAppView
              ? _c(
                  "button",
                  {
                    staticClass: "ym-btn search-button",
                    attrs: { type: "submit" }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("search")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ym-btn filter-toggle-button",
                attrs: { type: "button" },
                on: { click: _vm.toggleFilters }
              },
              [
                _c(
                  "i",
                  {
                    class: {
                      "material-icons": _vm.isMobileFiltersActive,
                      "material-icons-outlined": !_vm.isMobileFiltersActive
                    }
                  },
                  [_vm._v("")]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showFiltersView
        ? _c("filters-view", { on: { changed: _vm.changedFilters } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }